/* eslint-disable */
export default {
  today: 'Heute',
  yesterday: 'Gestern',
  empty: 'Keine Anrufdatensätze',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
